module.exports = __webpack_public_path__ + "static/media/banner_1.d10af9e2.jfif";